<div class="container m-b-large">
  <div class="images" [ngStyle]="{'background': 'url(./assets/images/vedra.jpg)'}"></div>
</div>
